import { useEffect, useRef, useState } from 'react'
import { propertiesService } from '../services/propertiesService'
import { useAuth } from '../contexts/AuthContext'

export const useAnalytics = (region, enabled) => {
  const { authenticated } = useAuth()
  const [analyticsData, setAnalyticsData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const requestIdRef = useRef(0)

  useEffect(() => {
    const requestId = ++requestIdRef.current

    if (!authenticated || !enabled) {
      setAnalyticsData(null)
      setLoading(false)
      setError(null)
      return
    }

    const fetchAnalytics = async () => {
      try {
        setLoading(true)
        setError(null)
        const data = await propertiesService.fetchAnalytics(region)
        if (requestId === requestIdRef.current) setAnalyticsData(data)
      } catch (err) {
        if (requestId === requestIdRef.current) {
          console.error('Error fetching analytics:', err)
          setError(err)
        }
      } finally {
        if (requestId === requestIdRef.current) setLoading(false)
      }
    }

    fetchAnalytics()
  }, [authenticated, enabled, region])

  return { analyticsData, loading, error }
}
